import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useAppSelector } from "Redux/hooks";
import { selectStyle } from "Redux/appSlice";

type Props = {
  onClick: () => void;
  isOn: boolean;
  isPopulated?: boolean;
};

/*
  @function QuestionButton
  render question button that can be clicked
  @param onClick {function} - called function on click
  @param isPopulated {boolean} - there are guides/example in quesiton
  @returns {React.Node}
*/
export default function QuestionButton({
  onClick,
  isOn = false,
  isPopulated = false,
}: Props) {
  const [hovered, setHovered] = useState(false);
  const { color2 } = useAppSelector(selectStyle);

  return (
    <button
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: (isOn || hovered ? color2 : "") }}    
      className={`w-5 md:w-9 h-5 md:h-9 rounded-full flex justify-center items-center md:ml-4 text-white transition-colors ${
        isOn ? "" : isPopulated ? "bg-black" : "bg-neutral-400"
      }`}
      onClick={() => {
        onClick();
      }}
    >
      <FontAwesomeIcon icon={faQuestion} />
    </button>
  );
}
